export default {
    enrollment: 'รอบลงทะเบียน',
    stuEnroll: 'ลงทะเบียน',
    document: 'แนะนำการใช้งาน',
    code: 'รหัสผู้เรียน',
    status: 'สถานะ',
    enrollDate: 'วันที่ลงทะเบียน',
    lastAccess: 'วันที่เข้าเรียนล่าสุด',
    completeDate: 'วันที่สำเร็จ',
    overallProgress: 'ร้อยละความก้าวหน้า',
    overallScore: 'คะแนน',
    completeGrade: 'เกรด',
    add: 'เพิ่มผู้เรียน',
    title: 'คำนำหน้า',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    middleName: 'ชื่อกลาง',
    student: 'ผู้เรียน',
    dob: 'วันเดือนปีเกิด',
    housecode: 'บ้านเลขที่',
    province: 'จังหวัด',
    district: 'อำเภอ',
    thumbol: 'ตำบล',
    postalCode: 'รหัสไปรษณีย์',
    telephone: 'หมายเลขโทรศัพท์',
    address: 'ถนน/ซอย/หมู่บ้าน',
    profileImageUrl: 'ภาพถ่าย',
    info: 'ข้อมูลผู้เรียน',
    citizenCode: 'เลขบัตรประจำตัวประชาชน',
    emailAddress: 'อีเมล์ส่วนตัว',
    courses: 'วิชาที่ลงทะเบียน',
    editEmail: 'เปลี่ยนอีเมล์',
    account: 'บัญชีผู้ใช้งาน',
    newEmail: 'อีเมล์ใหม่',
    changeEmailSend1: 'เราได้ทำการส่งอีเมล์ไปที่',
    changeEmailSend2: 'โปรดทำการตรวจสอบอีเมล์เพื่อดำเนินการยืนยันการเปลี่ยนแปลงอีเมล์',
    security: 'ความปลอดภัย',
    editActivities: 'ดู/แก้ไขข้อมูลการทำกิจกรรม',
    noCode: 'ไม่มีรหัสผู้เรียน',
    type: 'ประเภทผู้เรียน',
    findEnroll: 'ค้นหา/ลงทะเบียนวิชาใหม่',
    orders: 'การสั่งซื้อ/ชำระเงิน',
    schoolEmailAddress: 'อีเมล์ของมหาวิทยาลัย',
    invoice:{
        studentInfo:'ข้อมูลผู้เรียน',
        billInfo: 'ข้อมูลการจัดส่ง',
        useStudentAddress: 'ใช้ข้อมูลของผู้เรียน?',
        attachmentInfo: 'แนบไฟล์หลักฐาน',
        billName: 'ชื่อ-นามสกุล',
        billHousecode: 'บ้านเลขที่',
        billAddress: "หมู่ที่",
        billProvince: 'จังหวัด',
        billDistrict: 'อำเภอ',
        billThumbol: 'ตำบล',
        billPostalCode: 'รหัสไปรษณีย์',
        sendName: 'ชื่อ-นามสกุล',
        sendHousecode: 'บ้านเลขที่',
        sendAddress: "หมู่ที่",
        sendProvince: 'จังหวัด',
        sendDistrict: 'อำเภอ',
        sendThumbol: 'ตำบล',
        sendPostalCode: 'รหัสไปรษณีย์',
    },
    gradebook:"ผลการเรียน",
    server: 'เว็บไซต์หลัก',
    studentPortal: 'ระบบสำหรับผู้เรียน',
    apps: 'ระบบอื่นๆ',
    teacherPortal: 'ระบบสำหรับผู้สอน',
}